module.exports = __webpack_public_path__ + "img/blank-board.0d1ea17d.svg";